import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {  RemainingDocumentRequirement } from 'app/models/document-requirement/document-requirement.model';
import { Store } from '@ngxs/store';
import * as DA from 'app/store/deal/deal-documents/deal-document.actions';

@Component({
  templateUrl: './document-requirement-delete-dialog.component.html',
  styleUrl: './document-requirement-delete-dialog.component.scss',
  standalone: false
})
export class DeleteDocumentRequirementDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { requiredDocument: RemainingDocumentRequirement, dealId: number },
    public dialogRef: MatDialogRef<DeleteDocumentRequirementDialogComponent>,
    private store: Store
  ) { }

  close() {
    this.dialogRef.close();
  }

  deleteRequirement() {
    const { dealId, requiredDocument } = this.data;
    // Dispatch the DeleteDocumentRequest action
    this.store.dispatch(new DA.DeleteDocumentRequest(dealId, requiredDocument));
    this.close();
  }
}





